import React from "react"
import Heading from "@amzn/meridian/heading"

const Logo = () => {
    return (
        <Heading level={ 1 } type="h600">LITT</Heading>
    )
}

export default Logo